import type { QueryClient } from "@tanstack/react-query";
import type { ApiTag } from "./generated/api-tags.gen";

/**
 * Invalidate all queries tagged with the given OpenAPI tag.
 * Tags flow from FastAPI router tags → OpenAPI spec → codegen → query keys.
 */
export function invalidateByTag(qc: QueryClient, tag: ApiTag) {
  return qc.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey[0];
      return typeof key === "object" && key !== null
        && "tags" in key && Array.isArray(key.tags)
        && key.tags.includes(tag);
    },
  });
}
